


















































import DlgMemberNew from '../../../modules/members/_components/DlgMemberNew.vue';
import DlgMemberEdit from '../../../modules/members/_components/DlgMemberEdit.vue';
import DlgMemberDelete from '../../../modules/members/_components/DlgMemberDelete.vue';
import Card from '../../../components/material/Card.vue';
import {Component, Vue} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';

@Component({
  components: {
    DlgMemberNew,
    DlgMemberEdit,
    DlgMemberDelete,
    Card,
  },
})
export default class MembersList extends Vue {
  @Action('members/sendToAll') private sendToAll!: any;
  @Getter('members/all') private members!: any[];
  @Action('members/read') private readMembers!: () => any;

  private loading: boolean = false;
  private toAllSending: boolean = false;
  private headers: any[] = [
    {
      text: 'Bezeichnung',
      align: 'left',
      value: 'title',
    },
    {
      text: 'Email Geschäftlich',
      align: 'left',
      value: 'businessEmail',
    },
    {
      text: 'Email Privat',
      align: 'left',
      value: 'privateEmail',
    },
    {
      text: 'Newsletter URL',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Vorstand',
      align: 'left',
      value: '',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private search: string = '';

  private created(): void {
    this.loading = true;
    this.readMembers().then(() => {
      this.loading = false;
    });
  }

  private getUrl(data: any) {
    return `https://ihrespezialisten.at/newsletter/${data.slug}`;
  }
}
